function CurrentLocationIcon() {
  return (
    <svg width='17' height='18' viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.3682 2.39018V0.666016H8.61925V2.39018C5.46154 2.76768 2.95531 5.15685 2.5583 8.16602H0.749023V9.83268H2.5583C2.95531 12.8418 5.46066 15.231 8.61925 15.6085V17.3327H10.3682V15.6085C13.5259 15.231 16.033 12.8427 16.4291 9.83268H18.2384V8.16602H16.4291C16.033 5.15685 13.5259 2.76768 10.3682 2.39018ZM9.49372 13.9993C6.6001 13.9993 4.2469 11.7568 4.2469 8.99935C4.2469 6.24185 6.6001 3.99935 9.49372 3.99935C12.3873 3.99935 14.7405 6.24185 14.7405 8.99935C14.7405 11.7568 12.3873 13.9993 9.49372 13.9993Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default CurrentLocationIcon;
